// extracted by mini-css-extract-plugin
export var carrierTab = "_50-0";
export var carrierTabActive = "_50-1 _50-0";
export var carrierTabInactive = "_50-2 _50-0";
export var carrierTabLabel = "_50-3";
export var carrierTabLabelActive = "_50-4 _50-3";
export var carrierTabLabelInactive = "_50-5 _50-3";
export var carrierTabPercentage = "_50-6";
export var carrierTabPercentageActive = "_50-7 _50-6";
export var carrierTabPercentageInactive = "_50-8 _50-6";
export var carrierTabWinnable = "_50-9";
export var carrierTabWinnableActive = "_50-a _50-9";
export var carrierTabWinnableInactive = "_50-b _50-9";
export var comparisonContainer = "_50-d";
export var missingRateButton = "_50-n";
export var missingRateButtonActive = "_50-o _50-n";
export var missingRateButtonInactive = "_50-p _50-n";
export var missingRateButtonLabel = "_50-q";
export var missingRateButtonLabelActive = "_50-r _50-q";
export var missingRateButtonLabelInactive = "_50-s _50-q";
export var sidebar = "_50-c";
export var strategyButton = "_50-e";
export var strategyButtonActive = "_50-f _50-e";
export var strategyButtonDescription = "_50-k";
export var strategyButtonDescriptionActive = "_50-l _50-k";
export var strategyButtonDescriptionInactive = "_50-m _50-k";
export var strategyButtonInactive = "_50-g _50-e";
export var strategyButtonLabel = "_50-h";
export var strategyButtonLabelActive = "_50-i _50-h";
export var strategyButtonLabelInactive = "_50-j _50-h";
export var unitToggleButton = "_50-t";
export var unitToggleButtonActive = "_50-u _50-t";
export var unitToggleButtonInactive = "_50-v _50-t";
export var unitToggleButtonLabel = "_50-w";
export var unitToggleButtonLabelActive = "_50-x _50-w";
export var unitToggleButtonLabelInactive = "_50-y _50-w";